var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppButtonOk',{on:{"click":_vm.onClickNext}},[_vm._v("\n  シミュレーション一覧へ\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }